import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Button, Banner} from "@shopify/polaris";
import intl from "../../../../../../../i18n/intl";
// * 自定义组件
import VariantsTable from "./components/VariantsTable";
// * api
import { reqPostDropshipmanNewShippingInfo} from "../../../../../.././../api";
import _ from "lodash";
// * css
import "../../../../index.css";
import { useGetState } from "ahooks";

/**
 *
 * @param {Object} data 商品详情
 * @param {Function} setRuleForm 修改商品详情方法
 * @param {onSave} onSave 保存
 * @returns
 */
const Variants = ({ id, data, setRuleForm, onSave,productInfoData,productInfoSet}) => {
  const [tagsList, setTagsList] = useState([]);
  const [searchingShip,setSearchingShip] = useState(false)
  const [shippingData, setShippingData] = useState([]);
  const [currentNum,setCurrentNum,getCurrentNum] = useGetState(true)//限制获取最新的物流选择方式
  useEffect(() => {
    let isMount = true;
    if (isMount && Object.values(data).length >0) {
      getTagList(); // 获取标签
    }
    return ()=> isMount = false;
    // eslint-disable-next-line
  }, [data]);
  useEffect(() => {
    let isMount = false;
    
    if (!isMount && Object.values(data).length > 0 && getCurrentNum() ) {
      getShippingData(); // 获取物流方式
    }
    return ()=> isMount = true;
    // eslint-disable-next-line
  }, [id,data]);

  const getTagList = () => {
    const list = [];
    
    _.forEach(data?.Variants, (item) => {
      // 是否已经存在相同名称的标签
      
      
      if (item.option_one) {
        list.push({ field: "option_one", name: item.option_one });
      }
      if (item.option_two) {
        list.push({ field: "option_two", name: item.option_two });
      }
      if (item.option_three) {
        list.push({ field: "option_three", name: item.option_three });
      }
    });
    let lists = _.uniqBy(list,'name')//去重 是否已经存在相同名称的标签
    setTagsList(_.sortBy(lists, "option"));
    setCurrentNum(true)
  };

  // 获取物流方式
  const getShippingData = async () => {
    try {
    
    const params = {
      RecordId: id, // 商品id
      shippingToCountry:data?.shippingToCountry, // 收货地址
      sendGoodsCountry:data?.sendGoodsCountry, // 发货地址
    };
    setSearchingShip(true)
    const res = await reqPostDropshipmanNewShippingInfo(params);
    if (res && res.code === "200") {
      setShippingData(res.data);
      setCurrentNum(false)
      setSearchingShip(false)
    }else{
      setSearchingShip(false)
      setCurrentNum(true)
    }
       
    } catch (error) {
      console.log(currentNum);
    } 
  };
  // 全选数量
  const checkNum = useMemo(() => {
    const list = _.filter(data.Variants, (item) => {
      return item.checked;
    });
   
    return list.length;
  }, [data.Variants]);

  // 点击标签
  const handleClickTag = useCallback(
    async (tag) => {
      setCurrentNum(false)
      const list = _.cloneDeep(data.Variants);
      switch (tag.name) {
        case "All":
          _.forEach(list, (el) => {
            el.checked = 1;
          });
          break;
        case "None":
          _.forEach(list, (el) => {
            el.checked = 0;
          });
          break;
        default:
          _.forEach(list, (el) => {
            if (el[tag.field] === tag.name) {
              el.checked = 1;
            } else {
              el.checked = 0;
            }
          });
      }
      // 如果有修改
      if (!_.isEqual(list, data.Variants)) {
      await setRuleForm((preState) =>{
          let currentData = preState.variants
          let param = {...currentData,Variants:list}
          const params = {...preState,variants:param}
          return params;
        }
        );
        onSave("variants",'filter');
      }
    },
    // eslint-disable-next-line
    [data.Variants, checkNum]
  );

  // 变体属性标签
  const tagsNode = _.map(tagsList, (tag, index) => (
    <div
      key={index}
      className="product-variant-tags-item"
      style={{ display: "inline-block", padding: "0 8px" }}
    >
      <Button
        variant="plain"
        textAlign="left"
        disabled={data.status}
        onClick={() => handleClickTag(tag)}
      >
        {tag.name}
      </Button>
    </div>
  ));
  const content = (
    <VariantsTable
    productInfoData={productInfoData}
      productInfoSet={productInfoSet}
      data={data}
      id={id}
      setCurrentNum={setCurrentNum}
      checkNum={checkNum}
      setRuleForm={setRuleForm}
      shippingData={shippingData}
      setShippingData={setShippingData}
      onSave={onSave}
      searchingShip={searchingShip}
    />
  )
  return (
    <div className="product-variant">
      <div className="product-variant-tags">
        <span className="mr-2">{intl.get("Quickly Select")}:</span>
        <div
          className="product-variant-tags-item"
          style={{ display: "inline-block", padding: "0 8px" }}
        >
          <Button
            variant="plain"
            textAlign="left"
            disabled={data.status}
            onClick={() => handleClickTag({ name: "All" })}
          >
            {intl.get("All")}
          </Button>
        </div>
        <div
          className="product-variant-tags-item"
          style={{ display: "inline-block", padding: "0 8px" }}
        >
          <Button
            variant="plain"
            textAlign="left"
            disabled={data.status}
            onClick={() => handleClickTag({ name: "None" })}
          >
            {intl.get("None")}
          </Button>
        </div>
        {/* 变体属性标签 */}
        {tagsNode}
      </div>

      <div className="mt-5 mb-5" style={{ margin: "1.25rem 0" }}>
        <Banner
          title=""
          tone={checkNum === 0 || checkNum > 100 ? "warning" : "info"}
        >
          <p>
            {checkNum === 0
              ? intl.get("Please select at least one product variant.")
              : checkNum > 100
              ? `${checkNum} ${intl.get(
                  "selected. Shopify allows a maximum of 100 variants per product. Please Split this product in More actions to import all variants."
                )}`
              : checkNum + intl.get("selected")+'.'}
          </p>
        </Banner>
      </div>

      {/* 判断对象是否为空 */}
      {Object.values(data).length > 0 ? content : ''}
      {/* </div> */}
    </div>
  );
};

export default Variants;
